module.exports = __webpack_public_path__ + "img/service_empty.0cd20793.png";